"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("src/utils/HelperUtils");
const WarningLockedWeight = ({ objective }) => {
    const handleAdjustWeight = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.handleAdjustWeight);
    const onClickAdjustWeight = () => {
        handleAdjustWeight(objective?.id, parseFloat(objective?.objectiveCategory?.weight));
    };
    return (react_1.default.createElement("p", { className: "warning-message text-r-600 typography-h100 mt-[8px]" },
        (0, HelperUtils_1.getObjectiveLocale)(`Current weight doesn't fit with the latest requirement`),
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", { className: "text-base-600 typography-h100 cursor-pointer", onClick: onClickAdjustWeight },
            ' ',
            (0, HelperUtils_1.getObjectiveLocale)('Click to adjust'))));
};
exports.default = WarningLockedWeight;
